import moment from 'moment-timezone'
import type { BusinessTimezone } from '../types/timezone'

export function getBusinessTimezoneName (business?: BusinessTimezone): string | undefined {
  return business?.location?.time_zone_name || business?.region?.time_zone_name
}

function parseBusinessLocalMoment (
  iso: string,
  business?: BusinessTimezone
): moment.Moment | null {
  const timezoneName = getBusinessTimezoneName(business)

  if (timezoneName) {
    const parsed = moment.tz(iso, timezoneName)
    return parsed.isValid() ? parsed : null
  }

  if (business?.timezone) {
    const parsed = moment(iso).utcOffset(business.timezone, true)
    return parsed.isValid() ? parsed : null
  }

  return null
}

export function resolveTodayDateInBusinessTimezone (business?: BusinessTimezone): string {
  const timezoneName = getBusinessTimezoneName(business)

  if (timezoneName) {
    return moment.tz(timezoneName).format('YYYY-MM-DD')
  }

  if (business?.timezone) {
    return moment().utcOffset(business.timezone).format('YYYY-MM-DD')
  }

  return moment().format('YYYY-MM-DD')
}

export function resolveBusinessLocalNowIso (business?: BusinessTimezone): string {
  const timezoneName = getBusinessTimezoneName(business)

  if (timezoneName) {
    return moment.tz(timezoneName).format('YYYY-MM-DDTHH:mm')
  }

  if (business?.timezone) {
    return moment().utcOffset(business.timezone).format('YYYY-MM-DDTHH:mm')
  }

  return moment().format('YYYY-MM-DDTHH:mm')
}

export function formatBusinessLocalDateTime (
  iso: string,
  business?: BusinessTimezone
): string {
  const parsed = parseBusinessLocalMoment(iso, business)
  if (parsed) {
    return parsed.format('lll')
  }

  const match = iso.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/)
  if (match) {
    const [, day, hour, minute] = match
    const date = new Date(`${day}T${hour}:${minute}:00`)
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }
  }

  return iso
}
